import React from 'react'
import ReactCodeInput from 'react-verification-code-input'
import './VerificationCodeInput.css'

const VerificationCodeInput = props => <ReactCodeInput {...props} />

export default VerificationCodeInput
